import { render, staticRenderFns } from "./localeSwitch.vue?vue&type=template&id=28e660ec&"
import script from "./localeSwitch.vue?vue&type=script&lang=js&"
export * from "./localeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./localeSwitch.vue?vue&type=style&index=0&id=28e660ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports